import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#enter-date" }),
  /*#__PURE__*/_createTextVNode(" Enter Date ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Basic date picker measured by 'day'. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "block mb-5" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Default", -1)
const _hoisted_7 = { class: "block" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", {
  class: "demonstration",
  style: {"margin-right":"5px"}
}, "Picker with quick options", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value1,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value1 = $event)),
          type: "date",
          placeholder: "Pick a day"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.value2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.value2 = $event)),
          type: "date",
          placeholder: "Pick a day",
          "disabled-date": _ctx.disabledDate,
          shortcuts: _ctx.shortcuts
        }, null, 8, ["modelValue", "disabled-date", "shortcuts"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}